const memory = {
  title: 'Memory',
  selectOrganization: 'Select an organization to see its memory.',
  add: 'Memory',
  search: 'Search memories',
  filterStatus: 'Status',
  filterKind: 'Kind',
  filters: 'Filters',
  clear: 'Clear',
  noResults: 'No memory matches these filters.',
  empty: 'Nothing remembered here yet.',
  loadError: 'The memories could not be loaded.',
  status: {
    active: 'Active',
    pending: 'Indexing',
    failed: 'Not indexed',
    expired: 'Expired',
  },
  statusHint: {
    pending: 'Being added to the graph — agents can already list it.',
    failed: 'Could not be added to the graph yet; it will be retried.',
  },
  kinds: {
    fact: 'Fact',
    decision: 'Decision',
    preference: 'Preference',
    event: 'Event',
  },
  sources: {
    ui: 'Screen',
    conversation: 'Conversation',
    workflow: 'Workflow',
  },
  validity: {
    permanent: 'Permanent',
    until: 'Until {{date}}',
    expiringSoon: 'Expires {{date}}',
    expired: 'Expired on {{date}}',
  },
  by: 'by {{name}}',
  via: 'via {{client}}',
  actions: {
    edit: 'Edit',
    renew: 'Renew',
    forget: 'Forget',
    facts: 'Facts',
  },
  form: {
    createTitle: 'New memory',
    editTitle: 'Edit memory',
    renewTitle: 'Renew memory',
    content: 'What to remember',
    contentPlaceholder: 'One short statement, e.g. "Maria Souza is responsible for the data team since October 2026."',
    kind: 'Kind',
    scope: 'Who sees it',
    scopeOptions: {
      user: 'Only me',
      workspace: 'This workspace',
      organization: 'The organization',
    },
    scopeHint: 'Moving it changes who reads it. It disappears from this list.',
    validity: 'Validity',
    validityOptions: {
      permanent: 'Permanent',
      '1d': '1 day',
      '7d': '7 days',
      '30d': '30 days',
      custom: 'Until a date',
    },
    validityHint: 'Temporary information (vacations, current sprint, an outage) should have a validity: after it, agents stop using it.',
    date: 'Valid until',
    invalidDate: 'Choose a future date.',
    save: 'Save',
    cancel: 'Cancel',
    created: 'Remembered.',
    updated: 'Memory updated.',
    saveError: 'The memory could not be saved.',
  },
  forget: {
    title: 'Forget this memory?',
    description: 'It disappears for every agent and person immediately. The history keeps who forgot it and when, but not the content.',
    confirm: 'Forget',
    forgetting: 'Forgetting…',
    cancel: 'Cancel',
    done: 'Forgotten.',
    error: 'The memory could not be forgotten.',
  },
  facts: {
    title: 'Facts in the graph',
    description: 'What the agents extracted from this memory. A replaced fact stays in the history, marked as no longer current.',
    empty: 'No facts yet — the memory may still be indexing.',
    current: 'Current',
    replaced: 'Replaced',
    since: 'since {{date}}',
    error: 'The facts could not be loaded.',
  },
} as const;

export default memory;
